<template>
    <span>
       <b-card no-body>
          <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Usuário</h3>
                 </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
             <b-form>
                 <b-alert show variant="success" v-if="mensagem_alteracao_basica">Usuário alterado com sucesso. Para atualização do nível de permissão no sistema é necessário sair e acessá-lo novamente.</b-alert>
                 <b-alert show variant="success" v-if="mensagem_alteracao_completa">Usuário alterado com sucesso. Sua solicitação foi encaminhada para aprovação. Para atualização do nível de permissão no sistema após aprovação é necessário sair e acessá-lo novamente.</b-alert>
             <b-row>
              <b-col cols="6">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'###.###.###-##'"
                                  id="cpf"
                                  type="text"
                                  :disabled="true"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="usuario.cpf"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Data de Nascimento:">
                  <b-input-group>
                    <div class="input-group-prepend">
                             <span class="input-group-text">
                               <i class='fa fa-calendar'></i>
                             </span>
                    </div>
                    <b-form-input id="type-date"
                                  type="date"
                                  v-model="usuario.data_nascimento"
                                  :state="chkState('date')"></b-form-input>
                    <b-form-invalid-feedback id="input1LiveFeedback2">Data de Nascimento é obrigatória.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="12">
                <b-form-group label="Nome:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model="usuario.nome"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="3">
                <b-form-group label="DDD + Telefone Celular">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  v-mask="'+55 (##) #####-####'"
                                  class="form-control"
                                  placeholder="Telefone Celular"
                                  autocomplete="telefone"
                                  v-model="usuario.telefone"
                                  :state="chkState('telefone')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="DDD + Telefone Fixo">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  v-mask="'+55 (##) ####-####'"
                                  class="form-control"
                                  placeholder="Telefone Fixo"
                                  autocomplete="telefone"
                                  v-model="usuario.telefone_fixo"
                                  :state="chkState('telefoneFixo')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback24">Telefone fixo é inválido.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="UF:">
                  <b-form-select v-model="usuario.estado_id" placeholder="Password" :options="estados"
                                 class="mb-3" :state="chkState('uf')">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Município:">
                  <b-form-select placeholder="Password"
                                 :options="cidades"
                                 class="mb-3"
                                 v-model="usuario.cidade_id"
                                 :state="chkState('municipio')">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="12">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model="usuario.email"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="12">
                <b-form-group v-if="usuario.perfil_temporario !== null" label="Tipo de Usuário:">
                  <b-form-select v-model="usuario.perfil_temporario" :state="chkState('tipoUsuario')" placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
                <b-form-group v-else label="Tipo de Usuário:">
                  <b-form-select v-model="usuario.perfil_id" :state="chkState('tipoUsuario')" placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row v-if="!usuario.perfil_temporario && usuario.perfil_id !== 2 && usuario.perfil_id !== perfilAtual">
              <b-col cols="1">
                <div class="custom-control custom-checkbox">
                  <b-form-checkbox
                          v-model="valueAceiteTipoUsuario"
                          :options="options"
                          :state="valueAceiteTipoUsuario"
                          name="checkbox-validation"
                          class="teste">
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col cols="11">
                is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
              </b-col>
              <b-col cols="12"></b-col>
              <b-col cols="5"><br>
                <b-form-invalid-feedback :state="valueAceiteTipoUsuario">A aceitação é obrigatória para esse tipo de usuário.
                </b-form-invalid-feedback>
                <br>
              </b-col>
            </b-row>
             <b-row v-if="usuario.perfil_temporario && usuario.perfil_temporario !== 2 && usuario.perfil_temporario !== perfilAtual">
                 <b-col cols="1">
                <div class="custom-control custom-checkbox">
                  <b-form-checkbox
                          v-model="valueAceiteTipoUsuario"
                          :options="options"
                          :state="valueAceiteTipoUsuario"
                          name="checkbox-validation"
                          class="teste">
                  </b-form-checkbox>
                </div>
              </b-col>
                 <b-col cols="11">
                is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
              </b-col>
              <b-col cols="12"></b-col>
              <b-col cols="5"><br>
                <b-form-invalid-feedback :state="valueAceiteTipoUsuario">A aceitação é obrigatória para esse tipo de usuário.
                </b-form-invalid-feedback>
                <br>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
          <b-card-footer class="p-12">
            <b-button variant="primary" @click="onSubmit"><i class="fa fa-check"></i> Salvar</b-button>
            <b-button variant="primary" @click="modalAlterarSenha = true"><i class="fa fa-key"></i> Alterar Senha</b-button>
            <b-button variant="secondary" @click="$router.go(-1)"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>
        </b-card-footer>
       </b-card>
        <b-modal id="modal-prevent-closing" ref="modal" title="Alterar Senha" ok-title="Salvar" cancel-title="Voltar" v-model="modalAlterarSenha" @show="limparModal" @hidden="limparModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="alterarSenha">
              <b-form-group :state="senhaAtualState" label="Senha Atual:" label-for="senha-atual-input" invalid-feedback="O campo Senha Atual é obrigatório!">
                <b-form-input id="senha-atual-input" type="password" v-model="senhaAtual" :state="senhaAtualState" required></b-form-input>
              </b-form-group>
              <b-form-group :state="senhaNovaState" label="Nova Senha:" label-for="nova-senha-input" invalid-feedback="O campo para Nova Senha é obrigatório!">
                <b-form-input id="nova-senha-input" type="password" v-model="senhaNova" :state="senhaNovaState" required></b-form-input>
              </b-form-group>
              <b-form-group :state="senhaNovaConfirmaState" label="Confirma a Senha:" label-for="confirma-senha-input" invalid-feedback="O campo para Confirmação de senha é obrigatório!">
                <b-form-input id="confirma-senha-input" type="password" v-model="senhaNovaConfirma" :state="senhaNovaConfirmaState" required></b-form-input>
              </b-form-group>
            </form>
        </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarCidades')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      valueAceiteTipoUsuario: false,
      options: [
        {value: true}
      ],
      senhaAtual: '',
      senhaNova: '',
      senhaNovaConfirma: '',
      senhaAtualState: null,
      senhaNovaState: null,
      senhaNovaConfirmaState: null,
      submittedNames: [],
      modalAlterarSenha: false,
      mensagem_alteracao_basica: false,
      mensagem_alteracao_completa: false
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    perfilAtual () {
      return this.$store.state.usuario.perfilAtual
    }
  },
  watch: {
    'usuario.estado_id': function () {
      if (this.usuario.estado_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.usuario.estado_id)
      }
    }
  },
  methods: {
    salvar () {
      let data
      let bool = 'simples' // mensagem simples

      data = {
        cpf: this.usuario.cpf.replace(/[^\d]+/g, ''),
        data_nascimento: this.usuario.data_nascimento,
        nome: this.usuario.nome,
        telefone: this.usuario.telefone.replace(/[^\d]+/g, ''),
        telefone_fixo: this.usuario.telefone_fixo,
        estado_id: parseInt(this.usuario.estado_id),
        cidade_id: parseInt(this.usuario.cidade_id),
        email: this.usuario.email,
        email_confirmation: this.usuario.email,
        perfis: JSON.stringify([{ id: this.usuario.perfil_id }]),
        ativo: this.usuario.ativo,
        situacao: this.usuario.situacao
      }

      if (this.usuario.perfil_temporario) {
        if (this.usuario.perfil_temporario === 2 && this.usuario.perfil_temporario !== this.perfilAtual) {
          data.situacao = true
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = null
          bool = 'basica'
        } else if (this.usuario.perfil_temporario > 2 && this.usuario.perfil_temporario !== this.perfilAtual) {
          data.situacao = false
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = this.usuario.perfil_temporario
          bool = 'completa'
        }
      } else {
        if (this.usuario.perfil_id === 2 && this.usuario.perfil_id !== this.perfilAtual) {
          data.situacao = true
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = null
          bool = 'basica'
        } else if (this.usuario.perfil_id > 2 && this.usuario.perfil_id !== this.perfilAtual) {
          data.situacao = false
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = this.usuario.perfil_id
          bool = 'completa'
        }
      }

      Vue.http.put('api/usuario/update/' + SessionStorage.get('usuario'), data).then(response => {
        if (response.body.success) {
          if (bool === 'basica') {
            this.mensagem_alteracao_basica = true
            this.mensagem_alteracao_completa = false
            setTimeout(() => this.$router.push({path: '/'}), 10000)
          } else if (bool === 'completa') {
            this.mensagem_alteracao_basica = false
            this.mensagem_alteracao_completa = true
            setTimeout(() => this.$router.push({path: '/'}), 10000)
          } else {
            miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
            miniToastr.success(response.body.msg, 'Sucesso!', 4500)
            this.$router.push({path: '/'})
          }
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 3500)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    onSubmit () {
      if (this.validate() && this.validateTermos()) {
        this.confirmar()
      }
    },
    alterarSenha () {
      this.modalAlterarSenha = true
    },
    validate () {
      let result = true

      if (!this.usuario.data_nascimento) {
        result = false
      }

      if (!this.usuario.nome) {
        result = false
      }

      if (!this.usuario.telefone) {
        result = false
      } else if (this.usuario.telefone.length < 19) {
        result = false
      }

      if (!this.usuario.telefone_fixo) {
        result = true
      } else if (this.usuario.telefone_fixo.length < 18) {
        result = false
      }

      if (!this.usuario.estado_id) {
        result = false
      }

      if (!this.usuario.cidade_id) {
        result = false
      }

      if (!this.usuario.email) {
        result = false
      } else if (!this.validateEmail(this.usuario.email)) {
        result = false
      }

      return result
    },
    validateTermos () {
      let bool = true

      if (this.usuario.perfil_temporario) {
        if (this.usuario.perfil_temporario > 2 && this.usuario.perfil_temporario !== this.perfilAtual) {
          bool = false
        }
      } else {
        if (this.usuario.perfil_id > 2 && this.usuario.perfil_id !== this.perfilAtual) {
          bool = false
        }
      }

      if (!this.valueAceiteTipoUsuario && !bool) {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Aceite os termos para o tipo de usuário.', 'Alerta!', 5000)
        return bool
      } else {
        bool = true
      }

      return bool
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    chkState (val) {
      switch (val) {
        case 'date':
          return !!this.usuario.data_nascimento
        case 'nome':
          return !!this.usuario.nome
        case 'telefone':

          if (!this.usuario.telefone) {
            return false
          } else if (this.usuario.telefone.length < 19) {
            return false
          }
          return true
        case 'telefoneFixo':
          if (!this.usuario.telefone) {
            return true
          } else if (this.usuario.telefone_fixo.length < 18 && this.usuario.telefone_fixo.length !== 0) {
            return false
          }
          return true
        case 'uf':
          return !!this.usuario.estado_id
        case 'municipio':
          return !!this.usuario.cidade_id
        case 'email':
          if (!this.usuario.email) {
            return false
          } else if (!this.validateEmail(this.usuario.email)) {
            return false
          }
          return !!this.usuario.email
        case 'tipoUsuario':
          let perfilTemp = !!this.usuario.perfil_temporario
          let perfil = !!this.usuario.perfil_id

          if (perfilTemp || perfil) {
            return true
          }
          return false
        default:
          return false
      }
    },
    validateEmail: function (email) {
      let re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.senhaAtualState = !!this.senhaAtual
      this.senhaNovaState = !!this.senhaNova
      this.senhaNovaConfirmaState = !!this.senhaNovaConfirma
      return valid
    },
    limparModal () {
      this.senhaAtual = ''
      this.senhaNova = ''
      this.senhaNovaConfirma = ''
      this.senhaAtualState = null
      this.senhaNovaState = null
      this.senhaNovaConfirmaState = null
    },
    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    handleSubmit () {
      if (!this.checkFormValidity()) {
        return
      }

      let data

      data = {
        old_password: this.senhaAtual,
        new_password: this.senhaNova,
        new_password_confirmation: this.senhaNovaConfirma
      }

      Vue.http.post('api/usuario/alterarMinhaSenha', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 4500)
          setTimeout(() => this.$router.push({path: '/'}), 3500)
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 3500)
        }
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
      }).catch(e => {
        let response = e.body

        if (response.msg) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.msg, 'Alerta!', 5000)
        }

        if (response.errors) {
          let erros = response.errors

          if (erros.old_password !== undefined) {
            for (let erro of erros.old_password) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Alerta!', 15000)
            }
          }

          if (erros.new_password !== undefined) {
            for (let erro of erros.new_password) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Alerta!', 15000)
            }
          }

          if (erros.new_password_confirmation !== undefined) {
            for (let erro of erros.new_password_confirmation) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Alerta!', 15000)
            }
          }
        }

        this.limparModal()
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/site/interna/perfil/MeuPerfil.vue